<template>
  <section v-if="user" class="mainEdit form section section--grey">
    <div v-if="editMode" class="container">
      <ValidationObserver ref="mainEdit" tag="div" class="form__body">
        <div class="row">
          <div class="col-lg-2 offset-xl-1 col-md-3">
            <label
              for="upload-image"
              :class="'upload-image ' + (imageNotValid ? ' div-error ' : '')"
            >
              <div
                v-if="user_data && user_data.photo && !avatarImgLoaded"
                class="file-inner"
              >
                <div class="file-content">
                  <div class="file-title">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M13.5 4H7.5C7.10218 4 6.72064 4.16857 6.43934 4.46863C6.15804 4.76869 6 5.17565 6 5.6V18.4C6 18.8243 6.15804 19.2313 6.43934 19.5314C6.72064 19.8314 7.10218 20 7.5 20H16.5C16.8978 20 17.2794 19.8314 17.5607 19.5314C17.842 19.2313 18 18.8243 18 18.4V8.5L13.5 4Z"
                        fill="#929BAA"
                      />
                      <path
                        d="M13 4.5V8.5C13 8.77614 13.2239 9 13.5 9H17.5"
                        fill="white"
                      />
                    </svg>
                    <span>{{ user_data.photo.name }}</span>
                  </div>
                  <div class="file-size">
                    {{ Math.round(user_data.photo.size / 1024) }}kb
                  </div>
                  <div class="file-loader">
                    <div
                      class="file-loader__bar"
                      :style="
                        'width: ' +
                        (otherUploadPercentage ? otherUploadPercentage : '0') +
                        '%;'
                      "
                    />
                  </div>
                </div>
                <div v-if="otherUploadPercentage == 100" class="file-status">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="12" cy="12" r="8" fill="#29CC44" />
                    <path
                      d="M16 9.33203L10.8571 14.6654L8 11.7563"
                      stroke="white"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
              </div>
              <div
                v-show="loaderImg"
                class="upload-image__img-container loader-image"
              >
                <SimplePreloader />
              </div>
              <div v-show="imagePreview" class="upload-image__img-container">
                <div class="hover_upload-new">
                  <icon name="edit_class_column" />
                </div>
                <input
                  ref="file"
                  type="file"
                  accept=".png, .jpg, .jpeg, .gif"
                  max-size="2000"
                  class="upload-image__input"
                  @change="selectFile($event)"
                />

                <img
                  class="upload-image__upload-img"
                  :src="imagePreview ? '/storage/' + imagePreview : ''"
                  alt=""
                />
              </div>
              <div v-show="!imagePreview" class="upload-image__zone">
                <input
                  id="upload-image"
                  ref="file"
                  type="file"
                  accept=".png, .jpg, .jpeg, .gif"
                  max-size="2000"
                  class="upload-image__input"
                  @change="selectFile($event)"
                />
                <div class="upload-image__zone-icon">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12 16C13.6569 16 15 14.6569 15 13C15 11.3431 13.6569 10 12 10C10.3431 10 9 11.3431 9 13C9 14.6569 10.3431 16 12 16Z"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M20 17.4444C20 17.857 19.8468 18.2527 19.574 18.5444C19.3012 18.8361 18.9312 19 18.5455 19H5.45455C5.06878 19 4.69881 18.8361 4.42603 18.5444C4.15325 18.2527 4 17.857 4 17.4444V8.88889C4 8.47633 4.15325 8.08067 4.42603 7.78894C4.69881 7.49722 5.06878 7.33333 5.45455 7.33333H8.36364L9.81818 5H14.1818L15.6364 7.33333H18.5455C18.9312 7.33333 19.3012 7.49722 19.574 7.78894C19.8468 8.08067 20 8.47633 20 8.88889V17.4444Z"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <div class="upload-image__zone-title">טען תמונה</div>
                <div class="upload-image__zone-text">
                  גודל הקובץ המרבי<br />
                  mb20 הוא
                </div>
              </div>
              <div v-show="imageNotValid" class="form__field-error">
                {{ imageError }}
              </div>
            </label>
          </div>
          <div class="col-xl-9 col-lg-10 col-md-9">
            <div class="row">
              <div class="col-lg-3 col-sm-6">
                <div class="form__field">
                  <div class="form__field-label">שם פרטי</div>
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="שם פרטי"
                    vid="user.name"
                    rules="required"
                  >
                    <div class="form__field-error">
                      {{ errors[0] }}
                      <!--                                                                        {{ errors[0] }}-->
                    </div>

                    <input
                      v-model="user_data.name"
                      type="text"
                      :class="
                        'form__field-input ' + (errors[0] ? ' error ' : '')
                      "
                    />
                  </ValidationProvider>
                </div>
              </div>
              <div class="col-lg-3 col-sm-6">
                <div class="form__field">
                  <div class="form__field-label">שם משפחה</div>
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="שם משפחה"
                    vid="user.last_name"
                    rules="required"
                  >
                    <div class="form__field-error">
                      {{ errors[0] }}
                    </div>

                    <input
                      v-model="user_data.last_name"
                      type="text"
                      :class="
                        'form__field-input ' + (errors[0] ? ' error ' : '')
                      "
                    />
                  </ValidationProvider>
                </div>
              </div>
              <div class="col-lg-3 col-sm-6">
                <div class="form__field">
                  <div class="form__field-label">קטגוריה</div>
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="קטגוריה"
                    vid="student.student_status_id"
                    rules="required"
                  >
                    <div class="form__field-error">
                      {{ errors[0] }}
                      <!--                                                                        {{ errors[0] }}-->
                    </div>

                    <Select2
                      v-model="student_data.student_status_id"
                      :options="statuses"
                      :settings="{ language: 'he' }"
                      :class="errors[0] ? ' select-error ' : ''"
                    />
                  </ValidationProvider>
                </div>
              </div>
              <div class="col-lg-3 col-sm-6">
                <div class="form__field">
                  <div class="form__field-label">השתייכות ארגונית</div>
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="השתייכות ארגונית"
                    rules="required"
                    vid="student.organization_id"
                  >
                    <div class="form__field-error">
                      {{ errors[0] }}
                    </div>

                    <Select2
                      v-model="student_data.organization_id"
                      :options="organizations"
                      :class="errors[0] ? ' select-error ' : ''"
                    />
                  </ValidationProvider>
                  <!--
                                                                                                <select class="form__field-select">
                                                                                                    <option value="משרד הרווחה">משרד הרווחה</option>
                                                                                                </select>
                                    -->
                </div>
              </div>

              <div class="col-lg-3 col-sm-6">
                <div class="form__field">
                  <div class="form__field-label">מסגרת</div>

                  <ValidationProvider
                    v-slot="{ errors }"
                    name="מסגרת"
                    :rules="atLeastOneNotEmpty"
                    vid="user.institutions"
                  >
                    <div class="form__field-error">
                      {{ errors[0] }}
                    </div>

                    <CustomThreeSelectVue
                      :options="institutions"
                      v-model="institutions_ids_data"
                      :openDirection="'bottom'"
                      :class="errors[0] ? ' custom-select-error ' : ''"
                    ></CustomThreeSelectVue>
                  </ValidationProvider>
                </div>
              </div>
              <div class="col-lg-3 col-sm-6">
                <div class="form__field">
                  <div class="form__field-label">רשות</div>

                  <ValidationProvider
                    v-slot="{ errors }"
                    name="מסגרת"
                    :rules="atLeastOneNotEmpty"
                    vid="user.administrations"
                  >
                    <div class="form__field-error">
                      {{ errors[0] }}
                    </div>

                    <CustomThreeSelectVue
                      :options="administrations"
                      v-model="district_administrations_ids_data"
                      :openDirection="'bottom'"
                      :class="errors[0] ? ' custom-select-error ' : ''"
                    ></CustomThreeSelectVue>
                  </ValidationProvider>
                </div>
              </div>
              <div class="col-lg-3 col-sm-6">
                <div class="form__field">
                  <div class="form__field-label">קבוצה</div>

                  <ValidationProvider
                    v-slot="{ errors }"
                    name="קבוצה"
                    vid="student.student_group_id"
                  >
                    <div class="form__field-error">
                      {{ errors[0] }}
                    </div>

                    <Select2
                      v-model="student_data.student_group_id"
                      :options="groups"
                      :class="errors[0] ? ' select-error ' : ''"
                    />
                  </ValidationProvider>
                </div>
              </div>
              <div class="col-lg-3 col-sm-6">
                <div class="form__field">
                  <div class="form__field-label">כיתה</div>
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="כיתה"
                    vid="student.student_class_id"
                  >
                    <div class="form__field-error">
                      {{ errors[0] }}
                    </div>

                    <Select2
                      v-model="student_data.student_class_id"
                      :options="classes"
                      :class="errors[0] ? ' select-error ' : ''"
                    />
                  </ValidationProvider>
                </div>
              </div>

              <div class="col-lg-4">
                <ValidationProvider
                  v-slot="{ errors }"
                  name="כיתה"
                  vid="student.student_class_id"
                >
                  <div v-show="periodNotValid" class="form__field-error">
                    {{ periodError }}
                  </div>

                  <div
                    :class="
                      'form__date-inner ' +
                      (periodNotValid ? ' div-error ' : '')
                    "
                  >
                    <div class="form__field mb-0">
                      <div class="form__field-label">תאריך קליטה</div>
                      <vDatepicker
                        class="datepicker_end"
                        :date="student_data.study_start"
                        :error="errors[0]"
                        border_none="true"
                        icon_none="true"
                        @change="changeStudy_start"
                      />
                    </div>

                    <div class="form__date-inner-sep">-</div>
                    <div class="form__field mb-0">
                      <div class="form__field-label">תאריך סיום צפוי</div>
                      <vDatepicker
                        :date="student_data.study_end"
                        :error="errors[0]"
                        border_none="true"
                        icon_none="true"
                        @change="changeStudy_end"
                      />
                    </div>
                  </div>
                </ValidationProvider>
              </div>
            </div>
          </div>
        </div>
      </ValidationObserver>
      <div class="form__footer d-flex justify-content-center">
        <button class="btn btn--blue btn--static" @click="saveData()">
          שמור שינויים
        </button>
        <button
          class="btn btn--border-grey btn--static"
          @click="changeMode(false)"
        >
          בטל שינויים
        </button>
      </div>
    </div>
    <div v-else class="student-form py-0">
      <div class="container">
        <div class="row">
          <div class="col-12 d-md-flex align-items-center">
            <div>
              <the-confirm
                title="אזהרה"
                :is-shown="showDeleteConfirm"
                question=" האם ברצונך להעביר את התלמידים האלה להסרה? (הם יוסרו מכיתות וקבוצות, הסטטוס יעודכן ל״לא סיימו״)."
                @ok="
                  deleteTrigger(true);
                  showDeleteConfirm = false;
                "
                @cancel="showDeleteConfirm = false"
              />
            </div>
            <div class="student-form__controls">
              <user-controls
                :block-user="
                  user.last_block &&
                  user.last_block !== null &&
                  (user.last_block.is_blocked === 1 ||
                    user.last_block.is_blocked === true)
                "
                classList="d-none align-items-center d-xl-flex"
                @unBlockUser="unBlockUser"
                @blockUser="blockUser"
                @changePasswordModal="changePasswordModal = true"
              />
              <div class="sep-line mx-4 d-none d-xl-flex"></div>
              <div
                v-if="$perm('student.edit', currentUser.campus_id)"
                class="student-form__edit-btn"
                @click="changeMode(true)"
              >
                <icon name="edit_class_column" />
              </div>
              <div class="sep-line mx-4 d-none d-xl-flex"></div>
              <div
                class="student-form__edit-btn"
                title="שליחת פרטי התחברות"
                @click="isSend = true"
              >
                <icon name="email-new" />
              </div>
            </div>
            <div class="student-form__ava">
              <div
                class="exit-status-red"
                v-if="
                  findExitPermission(student.exit_permission_user_statuses) ===
                  'expired_delay'
                "
              >
                <img class="image-status" src="/images/test-come.svg" />
                <span>חריגה בזמן</span>
              </div>
              <div
                class="exit-status"
                v-if="
                  findExitPermission(student.exit_permission_user_statuses) ===
                  'active_use'
                "
              >
                <img src="/images/exit.svg" class="image-status" />
                <span>בחוץ</span>
              </div>
              <div
                class="exit-status-in_campus"
                v-if="
                  findExitPermission(student.exit_permission_user_statuses) !==
                    'active_use' &&
                  findExitPermission(student.exit_permission_user_statuses) !==
                    'expired_delay'
                "
              >
                <img src="/images/inCampus.svg" class="image-status" />
              </div>
              <a
                href="#"
                v-if="
                  user.last_block &&
                  user.last_block !== null &&
                  (user.last_block.is_blocked === 1 ||
                    user.last_block.is_blocked === true)
                "
                class="btn btn--square-md btn--red"
              >
                <icon name="user-block" />
              </a>
              <img v-avatar-placeholder :src="'/storage/' + user.img" alt="" />
            </div>
            <div class="student-form__rows">
              <div class="student-form__row mb-md-8 mb-4">
                <div v-if="user && user.full_name" class="student-form__wrap">
                  <div class="student-form__title">
                    {{ user.full_name }}
                    <div
                      class="tooltip mr-2"
                      v-if="
                        user.last_block &&
                        user.last_block !== null &&
                        (user.last_block.is_blocked === 1 ||
                          user.last_block.is_blocked === true)
                      "
                    >
                      <div class="tooltip__icon">
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle cx="8" cy="8" r="8" fill="#FFCC33"></circle>
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M8.5 4L9 4.78349V5V5.21651L8.4996 8.9996H7.4996L7 5.21651V5V4.78349L7.5 4H8.5ZM7.36136 10.7418V11.9996H8.6954V10.7418H7.36136Z"
                            fill="#38455D"
                          ></path>
                        </svg>
                      </div>
                      <div class="tooltip__message">
                        {{ user.last_block.block_user.full_name }}
                        {{ blockDate }}
                      </div>
                    </div>
                  </div>
                  <div class="student-form__post">
                    {{ student.status.full_name }}
                  </div>
                </div>
              </div>
              <div class="student-form__row">
                <div class="student-form__info">
                  <div class="row">
                    <div class="col-md-5 col-xl-6">
                      <div class="student-form__info-item">
                        <div
                          class="
                            student-form__info-item-title
                            student-form__info-item-title--w-lg
                          "
                        >
                          רשות:
                        </div>
                        <div
                          class="student-form__info-item-value"
                          v-if="
                            student &&
                            student.user &&
                            student.user.district_administrations
                          "
                        >
                          <span
                            v-for="(adm, index) in student.user
                              .district_administrations"
                            :key="adm.id"
                          >
                            {{ adm.title }}
                            <span
                              v-if="
                                index <
                                student.user.district_administrations.length - 1
                              "
                              >,
                            </span>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-5 col-xl-6">
                      <div class="student-form__info-item">
                        <div
                          class="
                            student-form__info-item-title
                            student-form__info-item-title--w-lg
                          "
                        >
                          השתייכות ארגונית:
                        </div>
                        <div class="student-form__info-item-value">
                          {{
                            student.organization
                              ? student.organization.name
                              : '-'
                          }}
                        </div>
                      </div>
                    </div>

                    <div class="col-md-7 col-xl-6">
                      <div class="student-form__info-item">
                        <div
                          class="
                            student-form__info-item-title
                            student-form__info-item-title--w-md
                          "
                        >
                          מסגרת:
                        </div>
                        <div
                          class="student-form__info-item-value"
                          v-if="
                            student && student.user && student.user.institutions
                          "
                        >
                          <span
                            v-for="(inst, index) in student.user.institutions"
                            :key="inst.id"
                          >
                            {{ inst.title }}
                            <span
                              v-if="
                                index < student.user.institutions.length - 1
                              "
                              >,
                            </span>
                          </span>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-5 col-xl-6">
                      <div class="student-form__info-item">
                        <div
                          class="
                            student-form__info-item-title
                            student-form__info-item-title--w-lg
                          "
                        >
                          תקופת לימודים:
                        </div>
                        <div class="student-form__info-item-value">
                          {{ formatDate(student.study_start) }} -
                          {{ formatDate(student.study_end) }}
                        </div>
                      </div>
                    </div>
                    <div class="col-md-7 col-xl-8">
                      <div class="student-form__info-item">
                        <div
                          class="
                            student-form__info-item-title
                            student-form__info-item-title--w-md
                          "
                        >
                          קבוצה/כיתה:
                        </div>
                        <div class="student-form__info-item-value">
                          {{ student.group ? student.group.name : '' }} /
                          {{
                            student.student_class
                              ? student.student_class.class_name
                              : ''
                          }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <user-controls
            :block-user="
              user.last_block &&
              user.last_block !== null &&
              (user.last_block.is_blocked === 1 ||
                user.last_block.is_blocked === true)
            "
            classList="col-12 d-flex align-items-center justify-content-center d-xl-none mt-6"
            @unBlockUser="unBlockUser"
            @blockUser="blockUser"
            @changePasswordModal="changePasswordModal = true"
          />
        </div>
      </div>
      <StudentChangePassword
        v-if="changePasswordModal"
        @close="changePasswordModal = false"
        :user="user"
      />
    </div>
    <TheConfirm
      :is-shown="isSend"
      title="אזהרה"
      question="האם ברצונך לשלוח פרטי התחברות למערכת למשתמש זה?"
      @ok="sendMessage"
      @cancel="isSend = false"
    />
  </section>
</template>

<script>
// Packages
import axios from 'axios';
import { mapActions, mapGetters } from 'vuex';
// import Datepicker from 'vuejs-datepicker';
// import * as lang from 'vuejs-datepicker/src/locale';

import vDatepicker from '@/Components/UI/Form/vDatePicker';
// Validation
import { extend, ValidationObserver } from 'vee-validate';
import * as rules from 'vee-validate/dist/rules.js';
import { setInteractionMode } from 'vee-validate';
import Lang from 'vee-validate/dist/locale/he.json';
// Layouts
import TheConfirm from '@/Components/Alerts/TheConfirm';
import StudentChangePassword from '@/Pages/Student/Blocks/StudentChangePassword';
import SimplePreloader from '@/Components/SimplePreloader.vue';
import CustomThreeSelectVue from '@/Components/UI/Form/CustomThreeSelect.vue';

const messages = Lang.messages;

setInteractionMode('passive');
Object.keys(rules).forEach(rule => {
  extend(rule, {
    ...rules[rule], // copies rule configuration
    message: messages[rule] // assign message
  });
});

export default {
  name: 'MainEdit',
  components: {
    ValidationObserver,
    vDatepicker,
    TheConfirm,
    StudentChangePassword,
    SimplePreloader,
    CustomThreeSelectVue
  },
  props: {
    user: Object,
    student: Object,
    institutions_ids: Array,
    district_administrations_ids: Array
  },
  data() {
    return {
      isSend: false,
      showDeleteConfirm: false,
      editMode: false,
      language: Lang,
      institutions_ids_data: [],
      district_administrations_ids_data: [],
      imageNotValid: false,
      imageError: 'העלה תמונה',
      imagePreview: '',
      periodNotValid: false,
      periodError: 'חובה למלא את השדה תקופת הלימודים',
      campuses: [],
      statuses: [],
      organizations: [],
      groups: [],
      classes: [],
      user_data: [],
      student_data: [],
      changePasswordModal: false,
      loaderImg: false,
      avatarImgLoaded: false,
      otherUploadPercentage: 0,
      setNewStudy_start: null,
      study_start: '',
      setNewStudy_end: null,
      study_end: '',
      institutions: [],
      administrations: []
    };
  },
  computed: {
    atLeastOneNotEmpty() {
      return {
        required:
          this.district_administrations_ids_data.length === 0 &&
          this.institutions_ids_data.length === 0
      };
    },
    ...mapGetters({
      currentUser: 'auth/user'
    }),
    blockDate() {
      if (this.user.last_block) {
        return this.$convertDate(this.user.last_block.updated_at, '-', false);
      }
      return false;
    }
  },
  watch: {
    user_data(val) {
      if (val?.campus_id) {
        axios.get('/api/campus-classes/' + val?.campus_id).then(res => {
          this.classes = res.data.data;
        });
        axios.get('/api/campus-groups/' + val?.campus_id).then(res => {
          this.groups = res.data.data;
        });
      }
    },
    student(val) {
      if (val) {
        this.setDefaultDateStart(val.study_start);
        this.setDefaultDateEnd(val.study_end);
      } else {
        return;
      }
    },
    user(val) {
      if (val) {
      } else {
        return;
      }
      if (val.img) {
        this.imagePreview = val.img;
      }
    }
  },
  created() {
    this.user_data = this.user;
    console.log(this.user_data, ' this.user_data');
    this.student_data = this.student;
    this.institutions_ids_data = this.institutions_ids;
    this.district_administrations_ids_data = this.district_administrations_ids;
    axios
      .get('/api/main-info/institutions', {
        params: {
          short: 1
        }
      })
      .then(res => {
        const array = res.data.data.map(el => {
          return { ...el, label: el.title };
        });
        this.institutions = array;
      });
    axios
      .get('/api/main-info/district-administration', {
        params: {
          short: 1
        }
      })
      .then(res => {
        const array = res.data.data.map(el => {
          return { ...el, label: el.title };
        });
        this.administrations = array;
      });

    axios.get('/api/campuses').then(res => {
      this.campuses = res.data.data;
    });
    axios.get('/api/statuses').then(res => {
      this.statuses = res.data.data;
    });
    console.log(
      'student.exit_permission_user_statuses',
      this.student.exit_permission_user_statuses
    );
    axios.get('/api/organizations').then(res => {
      this.organizations = res.data.data;
      const null_value = {
        id: 0,
        text: '-'
      };
      this.organizations.unshift(null_value);
    });
    if (this.student.user && this.student.user.campus_id) {
      axios
        .get('/api/campus-classes/' + this.student.user.campus_id)
        .then(res => {
          this.classes = res.data.data;
        });
      axios
        .get('/api/campus-groups/' + this.student.user.campus_id)
        .then(res => {
          this.groups = res.data.data;
        });
    }
  },
  methods: {
    async sendMessage() {
      try {
        const respons = await axios.post('/api/send-user-credentials', {
          email: this.user.email,
          user_type: 'student'
        });
      } catch (error) {
        console.log(error);
      }
    },
    ...mapActions({
      updated: 'students/studentUpdated',
      nonUpdated: 'students/studentNotUpdated'
    }),
    changeStudy_start(date) {
      this.student_data.study_start = date;
    },
    changeStudy_end(date) {
      this.student_data.study_end = date;
    },
    deleteTrigger() {
      axios
        .post('/api/students/delete', { students: [this.student.id] })
        .then(res => {
          this.$router.push({
            name: 'StudentList'
          });
          this.$toastr.s('הוסר');
        })
        .catch(err => {
          this.$toastr.e('שגיאה');
        });
    },
    showDeleteConfirmAction() {
      if (this.page === 'table') {
        const table = this.$refs.studentsTable;
        if (table && table.students_data.map(s => s.selected).some(s => s)) {
          this.showDeleteConfirm = true;
        } else {
          return;
        }
      }
      this.showDeleteConfirm = true;
    },
    formatDate(date) {
      const old_date = new Date(date);
      let month = '' + (old_date.getMonth() + 1);
      let day = '' + old_date.getDate();
      const year = old_date.getFullYear();
      if (day.length < 2) {
        day = '0' + day;
      }
      if (month.length < 2) {
        month = '0' + month;
      }
      const new_date = day + '.' + month + '.' + year;

      return new_date;
    },
    setDefaultDateStart(date) {
      this.student_data.study_start = new Date(date);
    },
    setDefaultDateEnd(date) {
      this.student_data.study_end = new Date(date);
    },
    getDate(date) {
      return new Date(date);
    },
    // setStudyEnd(e) {
    //   const old_date = e;
    //   let month = '' + (old_date.getMonth() + 1);
    //   let day = '' + old_date.getDate();
    //   const year = old_date.getFullYear();
    //   if (day.length < 2) {
    //     day = '0' + day;
    //   }
    //   if (month.length < 2) {
    //     month = '0' + month;
    //   }
    //   const new_date = year + '-' + month + '-' + day;
    //   this.student_data.study_end = new_date;
    // },
    // setStudyStart(e) {
    //   const old_date = e;
    //   let month = '' + (old_date.getMonth() + 1);
    //   let day = '' + old_date.getDate();
    //   const year = old_date.getFullYear();
    //   if (day.length < 2) {
    //     day = '0' + day;
    //   }
    //   if (month.length < 2) {
    //     month = '0' + month;
    //   }
    //   const new_date = year + '-' + month + '-' + day;
    //   this.student_data.study_start = new_date;
    // },
    changeMode(value) {
      this.user_data = this.user;
      this.student_data = this.student;
      this.institutions_ids_data = this.institutions_ids;
      this.district_administrations_ids_data =
        this.district_administrations_ids;
      console.log(this.user_data);

      this.editMode = value;
    },
    selectCampus(event) {
      this.student.student_class_id = '';
      this.student.student_group_id = '';
      axios.get('/api/campus-classes/' + event).then(res => {
        this.classes = res.data.data;
      });
      axios.get('/api/campus-groups/' + event).then(res => {
        this.groups = res.data.data;
      });
    },

    selectFile(event) {
      this.loaderImg = true;
      this.avatarImgLoaded = false;
      this.otherUploadPercentage = 0;
      this.user_data.photo = event.target.files[0];
      const formData = new FormData();
      formData.append('img', this.user_data.photo);
      axios
        .post('/api/user-photo-store', formData, {
          headers: {
            accept: 'application/json',
            'Content-Type': 'multipart/form-data;'
          },
          onUploadProgress: function (progressEvent) {
            const progress = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
            this.otherUploadPercentage = progress;
          }.bind(this)
        })
        .then(res => {
          this.imagePreview = res.data;
          this.user_data.img = res.data;

          this.imageNotValid = false;
          this.$toastr.s('תמונה הועלתה');
        })
        .catch(err => {
          this.$toastr.e('שגיאה');
        })
        .finally(() => {
          this.loaderImg = false;
          this.avatarImgLoaded = true;
        });
    },

    async saveData() {
      this.nonUpdated();

      const valid = await this.$refs.mainEdit.validate();
      // if (!this.user_data.img) {
      //     this.imageNotValid = true;
      // }
      if (!this.student_data.study_start || !this.student_data.study_end) {
        this.periodNotValid = true;
      } else {
        this.periodNotValid = false;
      }
      if (this.imageNotValid || this.periodNotValid) {
        return;
      }
      const that = this;
      if (valid) {
        axios
          .put('/api/students/' + this.student.id, {
            user: this.user_data,
            student: this.student_data,
            institutions: this.institutions_ids_data,
            district_administrations: this.district_administrations_ids_data
          })
          .then(res => {
            this.updated();
            this.changeMode(false);
            this.$toastr.s('נשמר');
          })
          .catch(function (err) {
            const errors = err.response.data.errors;
            if (errors) {
              that.$refs.mainEdit.setErrors(errors);
              if (errors['user.img']) {
                that.imageNotValid = true;
                that.imageError = errors['user.img'][0];
              }
              if (errors['student.study_end']) {
                that.periodNotValid = true;
                that.periodError = errors['student.study_end'][0];
              }
              if (errors['student.study_start']) {
                that.periodNotValid = true;
                that.periodError = errors['student.study_start'][0];
              }
            }
            this.$toastr.e('שגיאה');
            // console.log(errors, errors.main, that.$refs.observer);
          });
      }
    },
    blockUser() {
      axios
        .post(`/api/user/${this.user.id}/block`)
        .then(res => {
          this.$emit('update');
        })
        .catch(err => {
          this.$toastr.e('שגיאה');
        });
    },
    unBlockUser() {
      axios
        .post(`/api/user/${this.user.id}/unblock`)
        .then(res => {
          this.$emit('update');
        })
        .catch(err => {
          this.$toastr.e('שגיאה');
        });
    },
    findExitPermission(exitArray) {
      let status = '';
      if (exitArray.length) {
        const expired = exitArray.findIndex(
          el => el.status === 'expired_delay'
        );
        if (expired == -1) {
          const active = exitArray.findIndex(el => el.status === 'active_use');
          if (active !== -1) {
            status = 'active_use';
          } else {
            status = false;
          }
        } else {
          status = 'expired_delay';
        }
      } else {
        status = false;
      }
      return status;
    }
  }
};
</script>

<style lang="scss" scoped>
.exit-status-red {
  right: 0px;
  display: flex;
  color: rgba(255, 245, 244, 1);
  justify-content: space-between;
  align-items: center;
  position: absolute;
  z-index: 1;
  width: 104px;
  font-size: 14px;
  height: 30px;
  background: rgba(255, 96, 82, 1);
  border-radius: 66px;
  padding-left: 5px;
  padding-right: 5px;
  img {
    width: 30px;
    height: 30px;
  }
}
.exit-status-in_campus {
  color: rgba(64, 159, 255, 1);
  position: absolute;
  z-index: 1;
}
.exit-status {
  right: 0px;
  display: flex;
  color: rgba(64, 159, 255, 1);
  justify-content: space-between;
  align-items: center;
  position: absolute;
  z-index: 1;
  width: 75px;
  height: 30px;
  background: white;
  border-radius: 66px;
  padding-left: 5px;
  padding-right: 5px;
  img {
    width: 30px;
    height: 30px;
  }
}
.student-form__ava {
  position: relative;
}
::v-deep .vue-treeselect__limit-tip-text {
  margin: 6px 0px 0 0 !important;
}
::v-deep .vue-treeselect__input-container {
  margin-top: 4px !important;
}
.custom-select-error {
  border: 1px solid #ff5040;
  border-radius: 4px;
}
::v-deep .custom-select .vue-treeselect__control {
  height: 40px;
  border: 1px solid #cfd3de;
  border-radius: 4px;
  padding: 0 12px;
  background: none;
}
::v-deep .vue-treeselect__x-container {
  // padding-left: 24px;
  // padding-bottom: 1px;
  display: none;
}
.three-select-student-add {
  position: relative;
  width: 100%;
  padding-right: 8px;
  padding-left: 8px;
  margin-bottom: 0;
  flex: 0 0 33%;
  max-width: 33%;
}
.file-inner {
  position: absolute;
  z-index: 3;
  .file-content {
    width: 100%;
    .file-title {
      width: 80%;
      font-size: 9px;
    }
  }
}
.loader-image {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  z-index: 2;
}
.hover_upload-new {
  padding: 10px;
  position: absolute;
  height: 100%;
  width: 100%;
  z-index: 0;
}
.upload-image__img-container:hover {
  .hover_upload-new {
    background-color: #e5f2ff;
    stroke: #409fff;
    opacity: 0.5;
    z-index: 2;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.mainEdit .vdp-datepicker__calendar {
  left: 0;
}
.form__date-inner {
  display: flex;
  align-items: flex-end;
}
.form__date-inner-sep {
  margin-bottom: 12px;
}
</style>
